import { render, staticRenderFns } from "./ContainerPage.vue?vue&type=template&id=955fb2a0&"
import script from "./ContainerPage.vue?vue&type=script&lang=ts&"
export * from "./ContainerPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('955fb2a0', component.options)
    } else {
      api.reload('955fb2a0', component.options)
    }
    module.hot.accept("./ContainerPage.vue?vue&type=template&id=955fb2a0&", function () {
      api.rerender('955fb2a0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ContainerPage.vue"
export default component.exports